var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverage-bar"},[_c('span',{staticClass:"track"},[_c('i',{style:({ width: (_vm.value + "%") })})]),_c('span',{staticClass:"pct"},[_vm._v(_vm._s(_vm.value)+" %")])])}
var staticRenderFns = []

export { render, staticRenderFns }